/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as AuthenticatedIndexRouteImport } from './routes/_authenticated/index'
import { Route as AuthenticatedUsersRouteImport } from './routes/_authenticated/users'
import { Route as AuthenticatedUserActionsRouteImport } from './routes/_authenticated/user-actions'
import { Route as AuthenticatedSettingsRouteImport } from './routes/_authenticated/settings'
import { Route as AuthenticatedProjectTypesRouteImport } from './routes/_authenticated/project-types'
import { Route as AuthenticatedCalendarRouteImport } from './routes/_authenticated/calendar'
import { Route as AuthenticatedKuraIndexRouteImport } from './routes/_authenticated/kura/index'
import { Route as KuraKuraIdStartNewDesign3RouteImport } from './routes/kura.$kuraId.start-new-design-3'
import { Route as KuraKuraIdStartNewDesign2RouteImport } from './routes/kura.$kuraId.start-new-design-2'
import { Route as KuraKuraIdStartNewDesignRouteImport } from './routes/kura.$kuraId.start-new-design'
import { Route as KuraKuraIdStartRouteImport } from './routes/kura.$kuraId.start'
import { Route as KuraKuraIdManualStartRouteImport } from './routes/kura.$kuraId.manual-start'
import { Route as AuthenticatedUserEditRouteImport } from './routes/_authenticated/user/edit'
import { Route as AuthenticatedKuraCreateRouteImport } from './routes/_authenticated/kura/create'
import { Route as AuthenticatedKuraKuraIdWinnersRouteImport } from './routes/_authenticated/kura/$kuraId/winners'
import { Route as AuthenticatedKuraKuraIdPropertiesRouteImport } from './routes/_authenticated/kura/$kuraId/properties'
import { Route as AuthenticatedKuraKuraIdParticipantsRouteImport } from './routes/_authenticated/kura/$kuraId/participants'
import { Route as AuthenticatedKuraKuraIdEditRouteImport } from './routes/_authenticated/kura/$kuraId/edit'
import { Route as AuthenticatedKuraKuraIdDuplicatesRouteImport } from './routes/_authenticated/kura/$kuraId/duplicates'

const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedIndexRoute = AuthenticatedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedUsersRoute = AuthenticatedUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedUserActionsRoute =
  AuthenticatedUserActionsRouteImport.update({
    id: '/user-actions',
    path: '/user-actions',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSettingsRoute = AuthenticatedSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedProjectTypesRoute =
  AuthenticatedProjectTypesRouteImport.update({
    id: '/project-types',
    path: '/project-types',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedCalendarRoute = AuthenticatedCalendarRouteImport.update({
  id: '/calendar',
  path: '/calendar',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedKuraIndexRoute = AuthenticatedKuraIndexRouteImport.update({
  id: '/kura/',
  path: '/kura/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const KuraKuraIdStartNewDesign3Route =
  KuraKuraIdStartNewDesign3RouteImport.update({
    id: '/kura/$kuraId/start-new-design-3',
    path: '/kura/$kuraId/start-new-design-3',
    getParentRoute: () => rootRouteImport,
  } as any)
const KuraKuraIdStartNewDesign2Route =
  KuraKuraIdStartNewDesign2RouteImport.update({
    id: '/kura/$kuraId/start-new-design-2',
    path: '/kura/$kuraId/start-new-design-2',
    getParentRoute: () => rootRouteImport,
  } as any)
const KuraKuraIdStartNewDesignRoute =
  KuraKuraIdStartNewDesignRouteImport.update({
    id: '/kura/$kuraId/start-new-design',
    path: '/kura/$kuraId/start-new-design',
    getParentRoute: () => rootRouteImport,
  } as any)
const KuraKuraIdStartRoute = KuraKuraIdStartRouteImport.update({
  id: '/kura/$kuraId/start',
  path: '/kura/$kuraId/start',
  getParentRoute: () => rootRouteImport,
} as any)
const KuraKuraIdManualStartRoute = KuraKuraIdManualStartRouteImport.update({
  id: '/kura/$kuraId/manual-start',
  path: '/kura/$kuraId/manual-start',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedUserEditRoute = AuthenticatedUserEditRouteImport.update({
  id: '/user/edit',
  path: '/user/edit',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedKuraCreateRoute = AuthenticatedKuraCreateRouteImport.update({
  id: '/kura/create',
  path: '/kura/create',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedKuraKuraIdWinnersRoute =
  AuthenticatedKuraKuraIdWinnersRouteImport.update({
    id: '/kura/$kuraId/winners',
    path: '/kura/$kuraId/winners',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedKuraKuraIdPropertiesRoute =
  AuthenticatedKuraKuraIdPropertiesRouteImport.update({
    id: '/kura/$kuraId/properties',
    path: '/kura/$kuraId/properties',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedKuraKuraIdParticipantsRoute =
  AuthenticatedKuraKuraIdParticipantsRouteImport.update({
    id: '/kura/$kuraId/participants',
    path: '/kura/$kuraId/participants',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedKuraKuraIdEditRoute =
  AuthenticatedKuraKuraIdEditRouteImport.update({
    id: '/kura/$kuraId/edit',
    path: '/kura/$kuraId/edit',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedKuraKuraIdDuplicatesRoute =
  AuthenticatedKuraKuraIdDuplicatesRouteImport.update({
    id: '/kura/$kuraId/duplicates',
    path: '/kura/$kuraId/duplicates',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/login': typeof LoginRoute
  '/calendar': typeof AuthenticatedCalendarRoute
  '/project-types': typeof AuthenticatedProjectTypesRoute
  '/settings': typeof AuthenticatedSettingsRoute
  '/user-actions': typeof AuthenticatedUserActionsRoute
  '/users': typeof AuthenticatedUsersRoute
  '/': typeof AuthenticatedIndexRoute
  '/kura/create': typeof AuthenticatedKuraCreateRoute
  '/user/edit': typeof AuthenticatedUserEditRoute
  '/kura/$kuraId/manual-start': typeof KuraKuraIdManualStartRoute
  '/kura/$kuraId/start': typeof KuraKuraIdStartRoute
  '/kura/$kuraId/start-new-design': typeof KuraKuraIdStartNewDesignRoute
  '/kura/$kuraId/start-new-design-2': typeof KuraKuraIdStartNewDesign2Route
  '/kura/$kuraId/start-new-design-3': typeof KuraKuraIdStartNewDesign3Route
  '/kura': typeof AuthenticatedKuraIndexRoute
  '/kura/$kuraId/duplicates': typeof AuthenticatedKuraKuraIdDuplicatesRoute
  '/kura/$kuraId/edit': typeof AuthenticatedKuraKuraIdEditRoute
  '/kura/$kuraId/participants': typeof AuthenticatedKuraKuraIdParticipantsRoute
  '/kura/$kuraId/properties': typeof AuthenticatedKuraKuraIdPropertiesRoute
  '/kura/$kuraId/winners': typeof AuthenticatedKuraKuraIdWinnersRoute
}
export interface FileRoutesByTo {
  '/login': typeof LoginRoute
  '/calendar': typeof AuthenticatedCalendarRoute
  '/project-types': typeof AuthenticatedProjectTypesRoute
  '/settings': typeof AuthenticatedSettingsRoute
  '/user-actions': typeof AuthenticatedUserActionsRoute
  '/users': typeof AuthenticatedUsersRoute
  '/': typeof AuthenticatedIndexRoute
  '/kura/create': typeof AuthenticatedKuraCreateRoute
  '/user/edit': typeof AuthenticatedUserEditRoute
  '/kura/$kuraId/manual-start': typeof KuraKuraIdManualStartRoute
  '/kura/$kuraId/start': typeof KuraKuraIdStartRoute
  '/kura/$kuraId/start-new-design': typeof KuraKuraIdStartNewDesignRoute
  '/kura/$kuraId/start-new-design-2': typeof KuraKuraIdStartNewDesign2Route
  '/kura/$kuraId/start-new-design-3': typeof KuraKuraIdStartNewDesign3Route
  '/kura': typeof AuthenticatedKuraIndexRoute
  '/kura/$kuraId/duplicates': typeof AuthenticatedKuraKuraIdDuplicatesRoute
  '/kura/$kuraId/edit': typeof AuthenticatedKuraKuraIdEditRoute
  '/kura/$kuraId/participants': typeof AuthenticatedKuraKuraIdParticipantsRoute
  '/kura/$kuraId/properties': typeof AuthenticatedKuraKuraIdPropertiesRoute
  '/kura/$kuraId/winners': typeof AuthenticatedKuraKuraIdWinnersRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/login': typeof LoginRoute
  '/_authenticated/calendar': typeof AuthenticatedCalendarRoute
  '/_authenticated/project-types': typeof AuthenticatedProjectTypesRoute
  '/_authenticated/settings': typeof AuthenticatedSettingsRoute
  '/_authenticated/user-actions': typeof AuthenticatedUserActionsRoute
  '/_authenticated/users': typeof AuthenticatedUsersRoute
  '/_authenticated/': typeof AuthenticatedIndexRoute
  '/_authenticated/kura/create': typeof AuthenticatedKuraCreateRoute
  '/_authenticated/user/edit': typeof AuthenticatedUserEditRoute
  '/kura/$kuraId/manual-start': typeof KuraKuraIdManualStartRoute
  '/kura/$kuraId/start': typeof KuraKuraIdStartRoute
  '/kura/$kuraId/start-new-design': typeof KuraKuraIdStartNewDesignRoute
  '/kura/$kuraId/start-new-design-2': typeof KuraKuraIdStartNewDesign2Route
  '/kura/$kuraId/start-new-design-3': typeof KuraKuraIdStartNewDesign3Route
  '/_authenticated/kura/': typeof AuthenticatedKuraIndexRoute
  '/_authenticated/kura/$kuraId/duplicates': typeof AuthenticatedKuraKuraIdDuplicatesRoute
  '/_authenticated/kura/$kuraId/edit': typeof AuthenticatedKuraKuraIdEditRoute
  '/_authenticated/kura/$kuraId/participants': typeof AuthenticatedKuraKuraIdParticipantsRoute
  '/_authenticated/kura/$kuraId/properties': typeof AuthenticatedKuraKuraIdPropertiesRoute
  '/_authenticated/kura/$kuraId/winners': typeof AuthenticatedKuraKuraIdWinnersRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/login'
    | '/calendar'
    | '/project-types'
    | '/settings'
    | '/user-actions'
    | '/users'
    | '/'
    | '/kura/create'
    | '/user/edit'
    | '/kura/$kuraId/manual-start'
    | '/kura/$kuraId/start'
    | '/kura/$kuraId/start-new-design'
    | '/kura/$kuraId/start-new-design-2'
    | '/kura/$kuraId/start-new-design-3'
    | '/kura'
    | '/kura/$kuraId/duplicates'
    | '/kura/$kuraId/edit'
    | '/kura/$kuraId/participants'
    | '/kura/$kuraId/properties'
    | '/kura/$kuraId/winners'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/login'
    | '/calendar'
    | '/project-types'
    | '/settings'
    | '/user-actions'
    | '/users'
    | '/'
    | '/kura/create'
    | '/user/edit'
    | '/kura/$kuraId/manual-start'
    | '/kura/$kuraId/start'
    | '/kura/$kuraId/start-new-design'
    | '/kura/$kuraId/start-new-design-2'
    | '/kura/$kuraId/start-new-design-3'
    | '/kura'
    | '/kura/$kuraId/duplicates'
    | '/kura/$kuraId/edit'
    | '/kura/$kuraId/participants'
    | '/kura/$kuraId/properties'
    | '/kura/$kuraId/winners'
  id:
    | '__root__'
    | '/_authenticated'
    | '/login'
    | '/_authenticated/calendar'
    | '/_authenticated/project-types'
    | '/_authenticated/settings'
    | '/_authenticated/user-actions'
    | '/_authenticated/users'
    | '/_authenticated/'
    | '/_authenticated/kura/create'
    | '/_authenticated/user/edit'
    | '/kura/$kuraId/manual-start'
    | '/kura/$kuraId/start'
    | '/kura/$kuraId/start-new-design'
    | '/kura/$kuraId/start-new-design-2'
    | '/kura/$kuraId/start-new-design-3'
    | '/_authenticated/kura/'
    | '/_authenticated/kura/$kuraId/duplicates'
    | '/_authenticated/kura/$kuraId/edit'
    | '/_authenticated/kura/$kuraId/participants'
    | '/_authenticated/kura/$kuraId/properties'
    | '/_authenticated/kura/$kuraId/winners'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  LoginRoute: typeof LoginRoute
  KuraKuraIdManualStartRoute: typeof KuraKuraIdManualStartRoute
  KuraKuraIdStartRoute: typeof KuraKuraIdStartRoute
  KuraKuraIdStartNewDesignRoute: typeof KuraKuraIdStartNewDesignRoute
  KuraKuraIdStartNewDesign2Route: typeof KuraKuraIdStartNewDesign2Route
  KuraKuraIdStartNewDesign3Route: typeof KuraKuraIdStartNewDesign3Route
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/': {
      id: '/_authenticated/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/users': {
      id: '/_authenticated/users'
      path: '/users'
      fullPath: '/users'
      preLoaderRoute: typeof AuthenticatedUsersRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/user-actions': {
      id: '/_authenticated/user-actions'
      path: '/user-actions'
      fullPath: '/user-actions'
      preLoaderRoute: typeof AuthenticatedUserActionsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/settings': {
      id: '/_authenticated/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthenticatedSettingsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/project-types': {
      id: '/_authenticated/project-types'
      path: '/project-types'
      fullPath: '/project-types'
      preLoaderRoute: typeof AuthenticatedProjectTypesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/calendar': {
      id: '/_authenticated/calendar'
      path: '/calendar'
      fullPath: '/calendar'
      preLoaderRoute: typeof AuthenticatedCalendarRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/kura/': {
      id: '/_authenticated/kura/'
      path: '/kura'
      fullPath: '/kura'
      preLoaderRoute: typeof AuthenticatedKuraIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/kura/$kuraId/start-new-design-3': {
      id: '/kura/$kuraId/start-new-design-3'
      path: '/kura/$kuraId/start-new-design-3'
      fullPath: '/kura/$kuraId/start-new-design-3'
      preLoaderRoute: typeof KuraKuraIdStartNewDesign3RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/kura/$kuraId/start-new-design-2': {
      id: '/kura/$kuraId/start-new-design-2'
      path: '/kura/$kuraId/start-new-design-2'
      fullPath: '/kura/$kuraId/start-new-design-2'
      preLoaderRoute: typeof KuraKuraIdStartNewDesign2RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/kura/$kuraId/start-new-design': {
      id: '/kura/$kuraId/start-new-design'
      path: '/kura/$kuraId/start-new-design'
      fullPath: '/kura/$kuraId/start-new-design'
      preLoaderRoute: typeof KuraKuraIdStartNewDesignRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/kura/$kuraId/start': {
      id: '/kura/$kuraId/start'
      path: '/kura/$kuraId/start'
      fullPath: '/kura/$kuraId/start'
      preLoaderRoute: typeof KuraKuraIdStartRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/kura/$kuraId/manual-start': {
      id: '/kura/$kuraId/manual-start'
      path: '/kura/$kuraId/manual-start'
      fullPath: '/kura/$kuraId/manual-start'
      preLoaderRoute: typeof KuraKuraIdManualStartRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/user/edit': {
      id: '/_authenticated/user/edit'
      path: '/user/edit'
      fullPath: '/user/edit'
      preLoaderRoute: typeof AuthenticatedUserEditRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/kura/create': {
      id: '/_authenticated/kura/create'
      path: '/kura/create'
      fullPath: '/kura/create'
      preLoaderRoute: typeof AuthenticatedKuraCreateRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/kura/$kuraId/winners': {
      id: '/_authenticated/kura/$kuraId/winners'
      path: '/kura/$kuraId/winners'
      fullPath: '/kura/$kuraId/winners'
      preLoaderRoute: typeof AuthenticatedKuraKuraIdWinnersRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/kura/$kuraId/properties': {
      id: '/_authenticated/kura/$kuraId/properties'
      path: '/kura/$kuraId/properties'
      fullPath: '/kura/$kuraId/properties'
      preLoaderRoute: typeof AuthenticatedKuraKuraIdPropertiesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/kura/$kuraId/participants': {
      id: '/_authenticated/kura/$kuraId/participants'
      path: '/kura/$kuraId/participants'
      fullPath: '/kura/$kuraId/participants'
      preLoaderRoute: typeof AuthenticatedKuraKuraIdParticipantsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/kura/$kuraId/edit': {
      id: '/_authenticated/kura/$kuraId/edit'
      path: '/kura/$kuraId/edit'
      fullPath: '/kura/$kuraId/edit'
      preLoaderRoute: typeof AuthenticatedKuraKuraIdEditRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/kura/$kuraId/duplicates': {
      id: '/_authenticated/kura/$kuraId/duplicates'
      path: '/kura/$kuraId/duplicates'
      fullPath: '/kura/$kuraId/duplicates'
      preLoaderRoute: typeof AuthenticatedKuraKuraIdDuplicatesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
  }
}

interface AuthenticatedRouteChildren {
  AuthenticatedCalendarRoute: typeof AuthenticatedCalendarRoute
  AuthenticatedProjectTypesRoute: typeof AuthenticatedProjectTypesRoute
  AuthenticatedSettingsRoute: typeof AuthenticatedSettingsRoute
  AuthenticatedUserActionsRoute: typeof AuthenticatedUserActionsRoute
  AuthenticatedUsersRoute: typeof AuthenticatedUsersRoute
  AuthenticatedIndexRoute: typeof AuthenticatedIndexRoute
  AuthenticatedKuraCreateRoute: typeof AuthenticatedKuraCreateRoute
  AuthenticatedUserEditRoute: typeof AuthenticatedUserEditRoute
  AuthenticatedKuraIndexRoute: typeof AuthenticatedKuraIndexRoute
  AuthenticatedKuraKuraIdDuplicatesRoute: typeof AuthenticatedKuraKuraIdDuplicatesRoute
  AuthenticatedKuraKuraIdEditRoute: typeof AuthenticatedKuraKuraIdEditRoute
  AuthenticatedKuraKuraIdParticipantsRoute: typeof AuthenticatedKuraKuraIdParticipantsRoute
  AuthenticatedKuraKuraIdPropertiesRoute: typeof AuthenticatedKuraKuraIdPropertiesRoute
  AuthenticatedKuraKuraIdWinnersRoute: typeof AuthenticatedKuraKuraIdWinnersRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedCalendarRoute: AuthenticatedCalendarRoute,
  AuthenticatedProjectTypesRoute: AuthenticatedProjectTypesRoute,
  AuthenticatedSettingsRoute: AuthenticatedSettingsRoute,
  AuthenticatedUserActionsRoute: AuthenticatedUserActionsRoute,
  AuthenticatedUsersRoute: AuthenticatedUsersRoute,
  AuthenticatedIndexRoute: AuthenticatedIndexRoute,
  AuthenticatedKuraCreateRoute: AuthenticatedKuraCreateRoute,
  AuthenticatedUserEditRoute: AuthenticatedUserEditRoute,
  AuthenticatedKuraIndexRoute: AuthenticatedKuraIndexRoute,
  AuthenticatedKuraKuraIdDuplicatesRoute:
    AuthenticatedKuraKuraIdDuplicatesRoute,
  AuthenticatedKuraKuraIdEditRoute: AuthenticatedKuraKuraIdEditRoute,
  AuthenticatedKuraKuraIdParticipantsRoute:
    AuthenticatedKuraKuraIdParticipantsRoute,
  AuthenticatedKuraKuraIdPropertiesRoute:
    AuthenticatedKuraKuraIdPropertiesRoute,
  AuthenticatedKuraKuraIdWinnersRoute: AuthenticatedKuraKuraIdWinnersRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  LoginRoute: LoginRoute,
  KuraKuraIdManualStartRoute: KuraKuraIdManualStartRoute,
  KuraKuraIdStartRoute: KuraKuraIdStartRoute,
  KuraKuraIdStartNewDesignRoute: KuraKuraIdStartNewDesignRoute,
  KuraKuraIdStartNewDesign2Route: KuraKuraIdStartNewDesign2Route,
  KuraKuraIdStartNewDesign3Route: KuraKuraIdStartNewDesign3Route,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
